<template>
  <div
    :class="
      'etiquette d-flex justify-content-center align-items-center mini-title m-auto ' +
      kind
    "
  >
    <p>{{ title }}</p>
  </div>
</template>
<script>
export default {
  props: ["status"],
  computed: {
    title: function () {
      switch (this.status) {
        case 0:
          return "پرداخت نشده";
          break;
        case 1:
          return "پرداخت شده";
          break;
        case 2:
          return "قبول شده";
          break;
        case 3:
          return "رد شده";
          break;
        case 4:
          return "در حال آماده سازی";
          break;
        case 5:
          return "در حال ارسال";
          break;
        case 6:
          return "تحویل داده شد";
          break;
        case 7:
          return "لغو شده";
          break;
        default:
          break;
      }
    },
    kind: function () {
      switch (this.status) {
        case 0:
          return "pending";
          break;
        case 1:
          return "paid";
          break;
        case 2:
          return "accept";
          break;
        case 3:
          return "rejected";
          break;
        case 4:
          return "preparing";
          break;
        case 5:
          return "sending";
          break;
        case 6:
          return "delivered";
          break;
        case 7:
          return "cancelled";
          break;
        default:
          break;
      }
    },
  },
};
</script>
<style scoped>
.etiquette {
  border-radius: 12px;
  font-size: 0.75rem;
  padding: 3px;
  max-width: 100px;
}

.etiquette p {
  margin: 0px;
  padding: 0px;
}
.delivered {
  background-color: rgba(52, 195, 166, 0.16);
  color: #34c3a6;
}
.paid {
  background-color: #2b99d84d;
  color: #0377bb;
}
.accept {
  background-color: rgb(215 163 255 / 65%);
  color: #6304c5;
}
.preparing {
  background-color: rgb(255 214 152 / 88%);
  color: #d53500;
}
.pending {
  background-color: rgba(255, 170, 0, 0.2);
  color: #d58e00;
}
.sending {
  background-color: rgb(244 255 152 / 88%);
    color: #585705;
}
.cancelled {
  background-color: rgba(255, 0, 0, 0.12);
  color: #ff0000;
}
.rejected {
  background-color: rgb(255 0 0 / 52%);
  color: #9e0707;
}
</style>